import { atom } from 'recoil';

import type { DomainCategorySizeType } from '@/Swagger';

export const sizeTypesMetadataState = atom<DomainCategorySizeType[]>({
  key: 'sizeTypesMetadataState',
  default: [],
});
